<section class="relative md:py-24 py-16 overflow-hidden">

  <div class="container">
    <div class="grid md:grid-cols-12 grid-cols-1 gap-[30px]">
        <div class="lg:col-span-5 md:col-span-6">
            <div class="relative">
                <div class="relative">
                    <img [src]="pagedata.foto1" class="lg:w-[400px] w-[280px] rounded-md shadow dark:shadow-gray-700" alt="">
                </div>
                <div class="absolute ltr:md:-right-5 ltr:right-0 rtl:md:-left-5 rtl:left-0 -bottom-16">
                    <img [src]="pagedata.foto2" class="lg:w-[280px] w-[200px] border-8 border-white dark:border-slate-900 rounded-md shadow dark:shadow-gray-700" alt="">
                </div>
            </div>
        </div>

        <div class="lg:col-span-7 md:col-span-6 mt-14 md:mt-0 tekst">
            <div [innerHTML]="pagedata.tekst | mdtohtml">
            </div>
        </div>
    </div><!--end grid-->
  </div><!--end container-->
</section>
